import { apiFetchMutiCouponList } from '@/api/imee'

const OriginPayList = ['Apple Pay', 'Google Pay']

// 作用：优惠券排序比较器，按 amount 降序 > expiredTime 升序 > minUseAmount 降序
function compareCouponPriority(a, b) {
  const amountDiff = (b.amount || 0) - (a.amount || 0)
  if (amountDiff !== 0) return amountDiff

  const expireDiff = (a.expiredTime || 0) - (b.expiredTime || 0)
  if (expireDiff !== 0) return expireDiff

  return (b.minUseAmount || 0) - (a.minUseAmount || 0)
}

export const mixin = {
  data() {
    return {
      scene: this.$route.query.scene || null,

      // 优惠券
      maxCoupon: null,
      showCoupons: false,
      selectedCoupon: null,
      validCouponList: [],

      // 默认支付方式-接口返回
      defaultChannel: '',
      originPayInfoReady: false,
      thirdPayListReady: false,

      // 支付结果
      showResultDia: false,
      payResultText: '',
    }
  },
  computed: {
    // 原生支付信息、三方支付列表均就绪后，执行默认选中
    defaultPaySelectionReady() {
      return this.originPayInfoReady && this.thirdPayListReady
    },
    // 筛选 canUse 为 true 的券并按排序规则返回可用列表
    availableCouponList() {
      return this.sortCouponList((this.validCouponList || []).filter((item) => item.canUse === true))
    },
    // 筛选 canUse 不为 true 的券并按排序规则返回不可用列表
    unavailableCouponList() {
      return this.sortCouponList((this.validCouponList || []).filter((item) => item.canUse !== true))
    },
    // 组装优惠券抽屉的可用/不可用两个分区数据
    couponDrawerSections() {
      return [
        {
          key: 'available',
          titleKey: 'lang.PayNext.k016',
          list: this.availableCouponList,
          selectable: true,
        },
        {
          key: 'unavailable',
          titleKey: 'lang.PayNext.k017',
          list: this.unavailableCouponList,
          selectable: false,
        },
      ]
    },
    // 判断是否存在可用于本次支付的优惠券（canUse 为 true）
    couponTriggerHasAvailable() {
      return (this.validCouponList || []).some((item) => item.canUse === true)
    },
    // 判断优惠券入口是否展示「已自动应用」文案（有可用券且已选中）
    couponTriggerApplied() {
      return this.couponTriggerHasAvailable && !!this.selectedCoupon
    },
  },
  watch: {
    // 原生支付信息、三方支付列表均就绪后，执行默认选中
    defaultPaySelectionReady(val) {
      if (val) {
        this.selectDefaultPayType()
      }
    },
  },
  methods: {
    // 跳转客服页面
    goCustomer() {
      this.appAction('open_customer_service_page', '')
    },

    // 获取shopType
    // prettier-ignore
    getShopType () {
      if (this.$route.query.shopType) {
        return this.$route.query.shopType
      }
      else {
        return this.scene == 'activity' ? 7 : null
      }
    },

    // 三方支付支付跳转外部页面-支付结果-客户端回调
    onNewIntent(url) {
      if (url) {
        const data = JSON.parse(url)
        if (data.status == 'PENDING') {
          this.payResultText = this.$t('lang.BaseCommon.k090')
          this.showResultDia = true
        }
        if (data.status == 'FAILED') {
          this.payResultText = this.$t('lang.BaseCommon.k089')
          this.showResultDia = true
        }
        if (data.status == 'CLOSED') {
          this.payResultText = this.$t('lang.PayNext.k026')
          this.showResultDia = true
        }
      }

      // 刷新页面
      this.init()
    },

    // 支付结果-关闭弹窗
    cancelAgain() {
      this.showResultDia = false
    },

    // 优惠券-初始化并自动应用最优券
    initCoupon() {
      this.resetCoupon()
      if (this.scene != 'activity') {
        const coinAmount = this.myPlus(this.amount, this.presentAmount)
        apiFetchMutiCouponList({ coinAmount })
          .then((resData) => {
            if (resData) {
              // 有效的
              this.validCouponList = resData.validCouponRecords || []
              this.findMaxCoupon(this.validCouponList, true)
            }
          })
          .finally(() => {
            this.notifyCheckoutPageReady?.()
          })
        return
      }
      this.notifyCheckoutPageReady?.()
    },

    // 优惠券-重置
    resetCoupon() {
      this.maxCoupon = null
      this.showCoupons = false
      this.selectedCoupon = null
      this.validCouponList = []
      this.invalidCouponList = []
    },

    // 对优惠券列表按统一优先级规则排序后返回新数组
    sortCouponList(list) {
      return [...(list || [])].sort(compareCouponPriority)
    },

    // 按排序规则找出最优可用券；useMax 为 true 时自动设为 selectedCoupon
    findMaxCoupon(couponList, useMax) {
      try {
        const sortedAvailable = this.sortCouponList((couponList || []).filter((item) => item.canUse === true))
        if (sortedAvailable.length) {
          const tempCoupon = sortedAvailable[0]
          this.maxCoupon = tempCoupon
          if (useMax) {
            this.selectedCoupon = tempCoupon
          }
        } else {
          this.maxCoupon = null
          if (useMax) {
            this.selectedCoupon = null
          }
        }
      } catch (err) {
        console.log('try catch err', err)
      }
    },

    // 优惠券-打开列表
    // 作用：打开/关闭优惠券抽屉，校验过期状态并刷新最优券与选中态
    handleClickCouponEnter() {
      if (this.showCoupons) {
        this.showCoupons = false
        return
      }

      if (this.validCouponList && this.validCouponList.length) {
        const nowTime = Date.now()
        this.validCouponList.forEach((item) => {
          if (nowTime > item.expiredTime) {
            item.canUse = false
          }
        })

        if (this.selectedCoupon) {
          const stillValid = this.availableCouponList.some((couponItem) => couponItem.couponRecordId === this.selectedCoupon.couponRecordId)
          if (!stillValid) {
            this.selectedCoupon = null
          }
        }

        this.findMaxCoupon(this.validCouponList, false)
      }

      this.showCoupons = this.availableCouponList.length > 0 || this.unavailableCouponList.length > 0
    },

    // 作用：格式化优惠券过期时间为抽屉展示文案（如 Jul 6, 2026）
    formatCouponExpiredTime(time) {
      return this.handleMoment(time, 'MMM D, YYYY')
    },

    // 优惠券-选择
    // 作用：选中或取消选中优惠券（再次点击已选券则取消）
    handleSelectCoupon(item) {
      if (item) {
        const itemHasSelected = this.selectedCoupon && this.selectedCoupon.couponRecordId === item.couponRecordId
        this.selectedCoupon = item
        if (itemHasSelected) {
          this.selectedCoupon = null
        }
      }
    },

    // 处理最优 和 上次使用显示
    resolveBestAndLastUsed() {
      if (this.payList.length) {
        const lastUsedChannelIndex = this.payList.findIndex((item) => item.name === this.lastUsedChannel)
        let lastUsedObj = null
        if (lastUsedChannelIndex > -1) {
          lastUsedObj = this.payList[lastUsedChannelIndex]
          lastUsedObj['lastUsed'] = true
        }

        const bestIndex = this.payList.findIndex((item) => item.ifBestPrice)
        let bestObj = null
        if (bestIndex > -1) {
          bestObj = this.payList[bestIndex]
          bestObj['best'] = true
        }
      }
    },

    // 支付方式-默认
    // prettier-ignore
    selectDefaultPayType() {
      try {
        // 原生支付(有原生支付&默认支付也是原生支付)
        if (OriginPayList.includes(this.defaultChannel) && this.googlePrice) {
          this.selectOriginPay()
          return
        }

        // 三方支付
        // 匹配defaultChannel同名方式-选中
        const tempIndex = this.payList.findIndex((item) => item.name === this.defaultChannel)
        if (tempIndex > -1) {
          this.selectThirdPay(this.payList[tempIndex], tempIndex)
        }
        // 无defaultChannel同名方式-选中第一个
        else {
          this.payList.length && this.selectThirdPay(this.payList[0], 0)
        }
      }
      catch (err) {
        console.log('try catch err', 'selectDefaultPayType')
      }
    },
  },
  mounted() {
    window.onNewIntent = this.onNewIntent
  },
}
